module.exports = __webpack_public_path__ + "static/media/logo_test.85eadf94.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo_test.png
// module id = 202
// module chunks = 0